import { MarkdownDocs } from '@mui/internal-core-docs/MarkdownDocs';
import * as pageProps from 'docs/data/tree-view/simple-tree-view/items/items.md?muiMarkdown';

export default function Page() {
  return <MarkdownDocs {...pageProps} />;
}
